import React from 'react';

import { Grid, Typography, Link } from '@mui/material';

interface Props {}

export const TutorRegistrationHeader: React.FC<Props> = () => {
  return (
    <Grid container spacing={3} alignItems="center" px={1}>
      <Grid item sm={12} lg={6}>
        <Typography fontWeight={400} fontSize={24} color="#000000">
          CADASTRAR TUTOR
        </Typography>
      </Grid>

      <Grid item container sm={12} lg={6} justifyContent="flex-end">
        <Link
          underline="none"
          fontSize={16}
          fontWeight={400}
          href="/tutor"
          sx={{ cursor: 'pointer' }}
        >
          Já sou cadastrado
        </Link>
      </Grid>
    </Grid>
  );
};
